import ts from 'typescript';
import { NodeCompiler } from '../NodeCompiler';
export class AwaitExpressionCompiler extends NodeCompiler {
    constructor() {
        super(...arguments);
        this.kind = ts.SyntaxKind.AwaitExpression;
    }
    visitNode(sb, expr) {
        sb.context.reportUnsupported(expr);
    }
}

//# sourceMappingURL=AwaitExpressionCompiler.js.map
